import React from "react";
import ManImg from "../images/man.png";
import styled from "styled-components";
import { fonts, colors, mediaQueries } from "../shared/config";
import Profile from "./Profile"

const Img = styled.img`
  margin-left: -55px;
  /* height: 683px; */
  width: 75%;
  ${mediaQueries.mobile} {
    margin-left: 0 !important;
    width: 90%;
  }
`;

const Box = styled.div`
  box-sizing: border-box;
  width: 775px;
  height: 219px;
  background: white;
  position: absolute;
  padding-left: 50px;
  right: -0.01vw;
  top: 232px;
  ${mediaQueries.mobile} {
    width: 100vw;
    height: 108px;
    right: 0;
    top: 120px;
  }
`;

const StrongTxt = styled.div`
  font-family: Staatliches;
  font-size: 96px;
  display: flex;
  color: ${colors.black1};
  ${mediaQueries.mobile} {
    font-size: 48px;
  }
`;

const WeakTxt = styled.div`
  font-family: Staatliches;
  font-size: 48px;
  display: flex;
  margin: auto 0;
  ${mediaQueries.mobile} {
    font-size: 24px;
  }
`;

const Container = styled.div`
  background: ${colors.red1};
  width: 100%;
  position: relative;
  padding-bottom: 40px;
  ${mediaQueries.mobile} {
    padding-bottom: 8px;
    width: 100%;
  }
`;

const PullQuoteBox = styled.div`
  width: 100vw;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  color: white;
  font-family: Staatliches;
  font-size: 48px;
  line-height: 90%;
  padding-top: 30px;
`;



const Quote = styled.div`
  font-family: Staatliches;
  font-style: normal;
  font-weight: normal;
  font-size: 1000px;
  line-height: 90%;
  color: ${colors.black1};
  margin-top: ${(props) => props.mt};
  ${mediaQueries.mobile} {
    display: none;
  }
`;

const QuoteTxt = styled.p`
  ${mediaQueries.mobile} {
    text-align: center;
    font-size: 26px;
  }
`;

const QuoteContainer = styled.div`
  display: flex;
  height: 400px;
  ${mediaQueries.mobile} {
    height: 180px;
    padding: 20px;
  }
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  padding-left: 10px;
  font-size: 12px;
`;

export default function Headoverheels(props){
  return (
    <>
      <Container>
        {props.data.map(block=>{
          if (block.type==="image_next_to_header") {
            return(
              <div>
                <Img src={block.image_link} alt="man"></Img>
                <Credits>{block.image_credits}</Credits>
              </div>    
            )
          }
        })}
        
        <Box>
          {props.data.map(block=>{
            if(block.type==="header") {
                return(<StrongTxt>{block.content}</StrongTxt>)
            }
            if(block.type==="subheader") {
                return(<WeakTxt>{block.content}</WeakTxt>)
            }                        
          })}
        </Box>
      </Container>
      {props.data.map(block=>{
        if(block.type==="individual"){
          return(<Profile data={block["content"]}/>)
        }
      })}
    </>
    
  );
};


